import { useEventListener } from "@vueuse/core";

/**
 * Toggles `--selected` on the table row of each menu that opens or closes inside `container`: an `sp-menu`
 * (its `update-open` event) or a legacy admin dropdown (`change-menu-appearance-state`, dispatched by
 * `app/assets/javascripts/admin/components/dropdown_menu.js`).
 *
 * @param {import("vue").Ref<EventTarget | null>} container - Ref to the element whose descendants' menu events are tracked.
 */
export function useMenuRowSelection(container) {
  function selectRow(target, open) {
    target.closest("tr")?.classList.toggle("--selected", Boolean(open));
  }

  function onMenuAppearance({ detail, target }) {
    selectRow(target, detail?.show);
  }

  function onMenuOpen({ detail, target }) {
    if (target.localName === "sp-menu") {
      selectRow(target, detail?.[0]);
    }
  }

  useEventListener(container, "change-menu-appearance-state", onMenuAppearance);
  useEventListener(container, "update-open", onMenuOpen, { capture: true });
}
